"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SectionHeader_1 = require("../Internals/SectionHeader");
const styled_1 = __importDefault(require("../utils/styled"));
const Icon_1 = require("../Icon");
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const constants_1 = require("../utils/constants");
const Container = styled_1.default.div `
  label: AccordionSectionContainer;
  /* to make sure it respects parrent grid's row height */
  overflow: hidden;
  /* to fix overflow: hidden above, otherwise header can disappear */
  display: grid;
  grid-template-rows: ${constants_1.headerHeight}px calc(100% - ${constants_1.headerHeight}px);
  /* for Focus */
  position: relative;
`;
const Header = styled_1.default(SectionHeader_1.SectionHeader)(({ theme, expanded }) => ({
    cursor: "pointer",
    borderTop: `1px solid ${theme.color.border.invisible}`,
    borderBottom: expanded ? `1px solid ${theme.color.border.invisible}` : "none",
    background: theme.color.background.almostWhite,
    // disable browser focus to customise focus state
    ":focus": {
        outline: "none",
        background: theme.color.border.select,
    },
    ".no-focus &:focus": {
        background: theme.color.background.almostWhite,
    },
    paddingRight: 0,
    userSelect: "none",
}));
Header.defaultProps = { role: "button", "aria-disabled": false };
const Panel = styled_1.default.div `
  label: AccordionPanel;
  /* we need it because of overflow: hidden; above */
  overflow: auto;
  height: 100%;
  padding: ${({ theme }) => theme.space.element}px;
  background-color: ${({ theme }) => theme.color.white};
`;
Panel.defaultProps = { role: "region" };
const IconWrapper = styled_1.default.div `
  width: ${constants_1.headerHeight}px;
  height: ${constants_1.headerHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const AccordionSection = ({ id, title, children, _index, _expanded, _toggleSection, }) => {
    const titleId = `${id}-${_index}-heading`;
    const contentId = `${id}-${_index}-panel`;
    if (_expanded === undefined || _index === undefined || _toggleSection === undefined) {
        throw new Error("Only AccordionSections can be used inside Accordion. See https://operational-ui.netlify.com/#!/Accordion for more info.");
    }
    return (React.createElement(Container, { expanded: _expanded },
        React.createElement(Header, { id: titleId, "aria-controls": contentId, "aria-expanded": _expanded, tabIndex: 0, onClick: () => _toggleSection(_index), onKeyPress: () => _toggleSection(_index), expanded: _expanded },
            title,
            React.createElement(IconWrapper, null, _expanded ? (React.createElement(Icon_1.ChevronUpIcon, { size: 20, onClick: () => {
                    /* Just for the hover style */
                }, tabIndex: -1 })) : (React.createElement(Icon_1.ChevronDownIcon, { size: 20, onClick: () => {
                    /* Just for the hover style */
                }, tabIndex: -1 })))),
        React.createElement(Panel, { id: contentId, "aria-labelledby": titleId, hidden: !_expanded }, _expanded && isFunction_1.default(children) ? children() : children)));
};
exports.default = AccordionSection;
//# sourceMappingURL=AccordionSection.js.map